{
  "entry": {
    "title": "オーダー入力",
    "subtitle": "コンピュータ化オーダー入力（CPOE）",
    "searchSection": {
      "title": "オーダーを検索・追加",
      "cosignNotice": "あなたのオーダーは有効化前に指導医の副署が必要です。"
    },
    "pending": {
      "title": "提出待ちオーダー",
      "clearAll": "すべてクリア",
      "collapseAria": "詳細を折りたたむ",
      "expandAria": "詳細を展開",
      "removeAria": "オーダーを削除",
      "startDateTime": "開始日時",
      "ariaStartDate": "オーダー開始日",
      "ariaStartTime": "オーダー開始時刻",
      "clinicalIndication": "臨床適応",
      "clinicalIndicationPlaceholder": "オーダー理由…",
      "specialInstructions": "特記事項",
      "specialInstructionsPlaceholder": "実施部門への追加指示…",
      "diagnosisLabel": "診断（ICD-10）",
      "diagnosisPlaceholder": "ICD-10 診断コードを検索…",
      "noActiveEncounter": "有効な受診がありません — オーダーを発行できません。",
      "placing": "送信中…",
      "placeAll": "すべて送信（{{count}}）"
    },
    "active": {
      "title": "有効なオーダー",
      "loading": "オーダーを読み込み中…",
      "emptyAll": "この患者のオーダーは見つかりませんでした。",
      "emptyFiltered": "{{type}} のオーダーは見つかりませんでした。",
      "columns": {
        "orderNumber": "オーダー番号",
        "name": "名称",
        "type": "種別",
        "priority": "優先度",
        "status": "ステータス",
        "orderedBy": "発行者",
        "orderedDate": "発行日",
        "actions": "操作"
      },
      "external": "外部",
      "externalTitle": "{{source}} からの外部オーダー",
      "externalTitleWithId": "{{source}} からの外部オーダー (#{{id}})",
      "providerPlaceholder": "医師 #{{id}}",
      "actions": {
        "complete": "完了",
        "cancel": "キャンセル",
        "completeTooltip": "オーダーを完了",
        "cancelTooltip": "オーダーをキャンセル"
      }
    },
    "cancelDialog": {
      "title": "オーダーをキャンセル",
      "prompt": "{{orderName}} をキャンセルする理由を入力してください。",
      "placeholder": "キャンセル理由（必須）…",
      "goBack": "戻る",
      "confirm": "キャンセルを確定"
    },
    "toast": {
      "cancelSuccess": "オーダーをキャンセルしました",
      "cancelError": "オーダーのキャンセルに失敗しました",
      "completeSuccess": "オーダーを完了としてマークしました",
      "completeError": "オーダーの完了に失敗しました",
      "noActiveEncounter": "この患者の有効な受診が見つかりません。先に受診を作成してください。",
      "placedSuccess_one": "{{count}} 件のオーダーを送信しました",
      "placedSuccess_other": "{{count}} 件のオーダーを送信しました",
      "medicationFieldsRequired_one": "{{names}} を処方するには用量・投与経路・投与頻度が必要です",
      "medicationFieldsRequired_other": "{{count}} 件の薬剤に用量・投与経路・投与頻度が必要です: {{names}}",
      "medicationNotInFormulary_one": "{{names}} はフォーミュラリーに紐付いておらず、アレルギー・相互作用・用量の確認ができません。薬剤ページから処方してください",
      "medicationNotInFormulary_other": "{{count}} 件の薬剤がフォーミュラリーに紐付いておらず確認できません: {{names}} — 薬剤ページから処方してください",
      "placedError_one": "{{count}} 件のオーダー送信に失敗しました",
      "placedError_other": "{{count}} 件のオーダー送信に失敗しました",
      "orderSetApplied": "「{{name}}」から {{count}} 件のオーダーを追加しました — 署名前に確認してください"
    }
  },
  "catalog": "オーダーカタログ",
  "orderedBy": "オーダー医",
  "orderedDate": "オーダー日",
  "scheduledDate": "予定日",
  "completedDate": "完了日",
  "lab": "検体検査",
  "imaging": "画像診断",
  "medication": "薬剤",
  "procedure": "処置",
  "consultation": "コンサルテーション",
  "priority": {
    "label": "優先度",
    "values": {
      "stat": "STAT",
      "asap": "ASAP",
      "urgent": "緊急",
      "routine": "定期",
      "scheduled": "予定",
      "prn": "PRN"
    }
  },
  "status": {
    "label": "オーダー状況",
    "values": {
      "draft": "下書き",
      "pending": "保留中",
      "pendingCosign": "副署待ち",
      "signed": "署名済み",
      "sent": "送信済み",
      "active": "有効",
      "ordered": "発行済み",
      "inProgress": "実施中",
      "holdForVerify": "確認待ち",
      "completed": "完了",
      "cancelled": "取消",
      "discontinued": "中止",
      "archived": "アーカイブ済み",
      "pendingClarification": "確認待ち",
      "suspended": "保留中",
      "unknown": "不明"
    }
  },
  "entryFields": {
    "searchPlaceholder": "オーダーを検索（検査・画像・薬剤・処置）…",
    "frequency": "頻度",
    "dose": "用量",
    "route": "投与経路",
    "indication": "適応",
    "duration": "期間",
    "comments": "備考",
    "signOrder": "オーダー署名",
    "holdOrder": "オーダー保留",
    "frequencyOptions": {
      "stat": "STAT",
      "prn": "PRN",
      "bid": "BID",
      "tid": "TID",
      "qid": "QID",
      "qd": "QD",
      "qhs": "QHS",
      "ac": "AC",
      "pc": "PC"
    }
  },
  "catalogPage": {
    "title": "オーダーカタログ",
    "searchPlaceholder": "名称・コード・同義語で検索…",
    "categories": "カテゴリ",
    "favorites": "お気に入り",
    "recentlyUsed": "最近使用",
    "restricted": "制限項目",
    "searchCatalog": "カタログを検索",
    "tabs": {
      "all": "すべて",
      "lab": "検査",
      "imaging": "画像",
      "medication": "薬剤",
      "procedure": "処置",
      "consultation": "コンサル"
    },
    "columns": {
      "orderName": "オーダー名",
      "code": "コード",
      "category": "カテゴリ",
      "description": "説明",
      "defaultPriority": "既定優先度"
    },
    "details": {
      "orderCode": "オーダーコード",
      "category": "カテゴリ",
      "defaultPriority": "既定優先度",
      "status": "状態",
      "cptCode": "CPTコード",
      "loincCode": "LOINCコード",
      "synonyms": "同義語",
      "description": "説明",
      "active": "有効",
      "inactive": "無効"
    },
    "loading": "カタログを読み込み中…",
    "loadError": "オーダーカタログの読み込みに失敗しました",
    "emptyResults": "条件に一致するオーダーが見つかりません。",
    "pagination": "{{total}} 件中 {{from}}-{{to}} 件を表示",
    "pageIndicator": "{{totalPages}} ページ中 {{page}} ページ目",
    "favoriteAdd": "お気に入りに追加",
    "favoriteRemove": "お気に入りから削除",
    "favoriteAdded": "お気に入りに追加しました",
    "favoriteRemoved": "お気に入りから削除しました"
  },
  "cosign": {
    "title": "オーダー副署キュー",
    "requiresCosign": "副署が必要",
    "cosignedBy": "副署者",
    "cosignDeadline": "副署期限",
    "queueEmpty": "副署が必要なオーダーはありません。",
    "pendingCount": "{{count}} 件保留中",
    "loading": "副署キューを読み込み中…",
    "loadError": "副署キューの読み込みに失敗しました。",
    "columns": {
      "patient": "患者",
      "order": "オーダー",
      "type": "種別",
      "orderingProvider": "オーダー医",
      "priority": "優先度",
      "orderedDate": "オーダー日",
      "action": "操作"
    },
    "actions": {
      "cosign": "副署"
    },
    "toast": {
      "success": "オーダーに副署しました",
      "error": "オーダー副署に失敗しました"
    },
    "cosigningAs": "{{name}} として副署"
  },
  "sets": {
    "title": "オーダーセット",
    "newOrderSet": "新規オーダーセット",
    "addItem": "項目を追加",
    "requiredItem": "必須",
    "optionalItem": "任意",
    "editMode": "編集モード",
    "published": "公開済み",
    "draft": "下書き",
    "archived": "アーカイブ済み",
    "versionNotes": "バージョン注記",
    "createTitle": "新規オーダーセット作成",
    "fields": {
      "name": "名称",
      "category": "カテゴリ",
      "specialty": "診療科",
      "description": "説明"
    },
    "placeholders": {
      "name": "例：胸痛精査",
      "categorySelect": "カテゴリを選択…",
      "specialty": "例：救急医学",
      "description": "簡単な説明…",
      "search": "オーダーセットを検索…"
    },
    "categories": {
      "chestPain": "胸痛",
      "sepsis": "敗血症",
      "postOp": "術後",
      "admission": "入院",
      "discharge": "退院",
      "other": "その他"
    },
    "statusFilter": {
      "all": "すべての状態",
      "active": "有効",
      "draft": "下書き",
      "archived": "アーカイブ済み"
    },
    "columns": {
      "name": "名称",
      "category": "カテゴリ",
      "specialty": "診療科",
      "items": "項目数",
      "status": "状態",
      "version": "バージョン",
      "actions": "操作"
    },
    "itemColumns": {
      "seq": "順序",
      "type": "種別",
      "item": "項目",
      "priority": "優先度",
      "required": "必須"
    },
    "itemTypes": {
      "order": "オーダー",
      "sectionHeader": "セクション見出し",
      "instruction": "指示"
    },
    "actions": {
      "publish": "公開",
      "archive": "アーカイブ",
      "cancel": "キャンセル",
      "create": "作成",
      "removeItem": "項目を削除"
    },
    "loading": "オーダーセットを読み込み中…",
    "loadError": "オーダーセットの読み込みに失敗しました",
    "emptyResults": "オーダーセットが見つかりません。",
    "expandLoading": "項目を読み込み中…",
    "expandEmpty": "このオーダーセットに項目はありません。",
    "validationRequired": "名称・カテゴリ・診療科は必須です",
    "toast": {
      "created": "オーダーセットを作成しました",
      "createError": "オーダーセットの作成に失敗しました",
      "published": "オーダーセットを公開しました",
      "publishError": "オーダーセットの公開に失敗しました",
      "archived": "オーダーセットをアーカイブしました",
      "archiveError": "オーダーセットのアーカイブに失敗しました",
      "itemRemoved": "項目を削除しました",
      "itemRemoveError": "項目の削除に失敗しました"
    },
    "versionBadge": "v{{version}}"
  },
  "search": {
    "placeholder": "オーダーを検索（検査・画像・薬剤・処置）…",
    "noResults": "\"{{query}}\" に一致するオーダーが見つかりません",
    "categories": {
      "all": "すべて",
      "lab": "検査",
      "imaging": "画像",
      "med": "薬剤",
      "procedure": "処置",
      "consultation": "コンサルト"
    },
    "addAll": "すべて追加（{{count}}）"
  },
  "worklist": {
    "title": "オーダーワークリスト",
    "countBadge": "{{count}}件のオーダー",
    "loading": "オーダーを読み込み中…",
    "loadError": "オーダーを読み込めませんでした。もう一度お試しください。",
    "empty": "現在のフィルタに一致するオーダーはありません。",
    "typeLabel": "オーダー種別",
    "allOption": "すべて",
    "columns": {
      "patient": "患者",
      "order": "オーダー",
      "type": "種別",
      "priority": "優先度",
      "status": "ステータス",
      "ordered": "オーダー日時"
    }
  }
}
